import { get } from 'lodash'
import React from 'react'

import config from 'config'
import * as Page from 'containers/pages'
import { Main } from 'components/masters'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/data-import`,
    exact: true,
    fullscreen: true,
    component: props => (
      <Main {...props}
            params={get(props, 'match.params', {})} >
        <Page.DataImport
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  },
  {
    path: `${publicPath}/profile`,
    exact: true,
    component: props => (
      <Main {...props}
            params={get(props, 'match.params', {})}>
        <Page.Person
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  },
  {
    path: `${publicPath}/reports`,
    exact: true,
    component: props => (
      <Main {...props}
            params={get(props, 'match.params', {})}>
        <Page.Reports
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  },
  {
    path: `${publicPath}/search`,
    exact: true,
    component: props => (
      <Main {...props}
            params={get(props, 'match.params', {})}>
        <Page.SearchResults
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  },
  {
    path: `${publicPath}/support`,
    exact: true,
    component: props => (
      <Main {...props}
            params={get(props, 'match.params', {})}>
        <Page.SupportPage
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  },
  {
    path: `${publicPath}/translations-management`,
    exact: true,
    component: props => (
      <Main {...props}
            params={get(props, 'match.params', {})}>
        <Page.TranslationsManagement
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  },
  {
    path: `${publicPath}/guides-and-policies`,
    exact: true,
    component: props => (
      <Main params={get(props, 'match.params', {})}
            {...props}>
        <Page.UserGuide
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  },
  {
    path: `${publicPath}/orb-lab`,
    exact: true,
    component: props => (
      <Main {...props}
            params={get(props, 'match.params', {})}>
        <Page.OrbLab
          {...props}
          params={get(props, 'match.params', {})}
        />
      </Main>
    )
  }
]

export default routes
